<template>
  <div class="home-wrapper">
    <div class="summary-box">
      <router-link to="/svi-izvodjaci" class="stat stat-link">
        <div class="stat-number">{{ formatNumber(totalSingers) }}</div>
        <div class="stat-label">Ukupno izvođača</div>
      </router-link>

      <router-link to="/sve-pjesme" class="stat stat-link">
        <div class="stat-number">{{ formatNumber(totalSongs) }}</div>
        <div class="stat-label">Ukupno pjesama</div>
      </router-link>
    </div>

    <h2 class="section-title">Posljednje dodane pjesme (zadnjih 500)</h2>
    <div class="song-scroll-box">
      <div v-for="(song, index) in recentSongs" :key="index" class="song-box">
        <div class="song-number">{{ index + 1 }}</div>
        <div class="song-info">
          <router-link :to="generateLink(song)" class="song-link">
            {{ song.songName }} — {{ song.singerName }}
          </router-link>
        </div>
        <div class="song-date">
          {{ formatDate(song.timestamp) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "@/firebase.js";
import { collection, getDocs, orderBy, limit, query } from "firebase/firestore";

export default {
  data() {
    return {
      recentSongs: [],
      totalSingers: 0,
      totalSongs: 0,
    };
  },
  methods: {
    formatNumber(number) {
      return number.toLocaleString("hr-HR");
    },

    async fetchRecentSongs() {
      const q = query(
        collection(db, "songs"),
        orderBy("timestamp", "desc"),
        limit(500)
      );

      const snapshot = await getDocs(q);
      this.recentSongs = snapshot.docs.map((doc) => doc.data());
    },

    async fetchStats() {
      const snapshot = await getDocs(collection(db, "songs"));
      const allSongs = snapshot.docs.map((doc) => doc.data());

      this.totalSongs = allSongs.length;
      const singerSet = new Set(allSongs.map((song) => song.singerName));
      this.totalSingers = singerSet.size;
    },

    generateLink(song) {
      const firstChar = song.singerName.charAt(0).toUpperCase();
      const letter = /^[0-9]/.test(firstChar) ? "0-9" : firstChar;
      return `/stranice/${letter}/${encodeURIComponent(
        song.singerName
      )}/${encodeURIComponent(song.songName)}`;
    },

    formatDate(timestamp) {
      if (!timestamp) return "";
      const date = timestamp.toDate();
      return date.toLocaleDateString("hr-HR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },
  },
  mounted() {
    this.fetchRecentSongs();
    this.fetchStats();
  },
};
</script>

<style scoped>
.home-wrapper {
  max-width: 800px;
  margin: 40px auto;
  padding: 20px 25px;
  background-color: rgba(255, 255, 255, 0.85);
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  border: 2px solid #804000;
  border-radius: 12px;
  background-image: url("@/assets/bgperg.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.summary-box {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 30px;
  padding: 16px;
  border: 2px solid #804000;
  border-radius: 12px;
  background-image: url("@/assets/bgperg.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.stat {
  text-align: center;
}

.stat-number {
  font-size: 28px;
  font-weight: bold;
  color: #2d0b00;
  text-shadow: 1px 1px 0 #d8b68a;
}

.stat-label {
  font-size: 16px;
  color: #2d0b00;
  margin-top: 4px;
}

.section-title {
  font-size: 24px;
  font-weight: bold;
  color: #2d0b00;
  margin-bottom: 12px;
  text-align: center;
}

.song-scroll-box {
  max-height: 300px;
  overflow-y: auto;
  padding-right: 5px;
  border: 1px solid #ccc;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.7);
}

.song-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f9f9f9;
  margin-bottom: 6px;
  padding: 6px 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 16px;
}

.song-number {
  font-weight: bold;
  width: 24px;
  text-align: center;
}

.song-info {
  flex: 1;
  margin: 0 10px;
  text-align: left;
}

.song-link {
  text-decoration: none;
  color: #2d0b00;
  font-weight: 500;
  font-family: "Times New Roman", Times, serif;
}

.song-link:hover {
  text-decoration: underline;
}

.song-date {
  font-size: 15px;
  color: #888;
  white-space: nowrap;
}

.stat-link {
  text-decoration: none;
  color: inherit;
  border-radius: 12px;
  transition: all 0.2s ease;
  position: relative;
}

.stat-link::after {
  content: "";
  position: absolute;
  left: 10%;
  bottom: 1px;
  width: 80%;
  height: 0.5px;
  background-color: #804000;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.stat-link:hover::after {
  opacity: 1;
}
</style>
